// extracted by mini-css-extract-plugin
export default {"button":"JumpToButton_button__z89Ar","hidden":"JumpToButton_hidden__jwX6M","buttonText":"JumpToButton_buttonText__R1wBJ"};